import requests from '@/utils/requests';

/**
 * 工单每日创建趋势
 * @param {*} data
 */
export function ticketDailyTrend(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/getTicketCreateTrend',
    method: 'post',
    data
  });
}

/**
 * 工单类型分布
 * @param {*} data
 */
export function getTicketPie(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/getTicketPie',
    method: 'post',
    data
  });
}

/**
 * 工单业务域分布
 * @param {*} data
 */
export function getTicketDomainPie(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/getTicketDomainPie',
    method: 'post',
    data
  });
}

/**
 * 工单业务域分布
 * @param {*} data
 */
export function getAIResultPie(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/getAIResultPie',
    method: 'post',
    data
  });
}

/**
 * 工单创建时间散点图
 * @param {*} data
 */
export function ticketCreateTime(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/ticketCreateTime',
    method: 'post',
    data
  });
}

/**
 * 工单处理时长
 * @param {*} data
 */
export function ticketSolveTime(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/ticketSolveTime',
    method: 'post',
    data
  });
}

/**
 * 工单处理时长
 * @param {*} data
 */
export function ticketSolveTimeTeam(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/ticketSolveTimeTeam',
    method: 'post',
    data
  });
}

/**
 * 工单Ai分类
 * @param {*} data
 */
export function ticketAIResult(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/queryTicketAiResp',
    method: 'post',
    data
  });
}

/**
 * 工单Ai分类
 * @param {*} data
 */
export function doGetChartList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/doGetChartList',
    method: 'post',
    data
  });
}

/**
 * 工单Ai分类
 * @param {*} data
 */
export function doGetAiQua(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/review/queryTicketQua',
    method: 'post',
    data
  });
}
